import { Component, Input } from "@angular/core";

@Component({
    selector: "app-reset-icon",
    templateUrl: "./reset-icon.component.html",
    styleUrls: ["./reset-icon.component.css"],
    standalone: false
})
export class ResetIconComponent {
    @Input() width!: string;
    @Input() height!: string;
    @Input() color!: string;
}
